module.exports = __webpack_public_path__ + "img/icon-anytime.8d25b23d.svg";